<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstGroupAction"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedGroupAction"
		dataKey="GroupActionID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--GroupActionTypeDesc-->
				<th>
					<!-- <p-columnFilter type="text" field="GroupActionTypeDesc" matchMode="contains" [showMenu]="true"></p-columnFilter> -->

					<p-columnFilter field="GroupActionTypeDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterGroupActionTypeDesc
								[ngModel]="value"
								[options]="lstGroupActionTypeDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--Description-->
				<th>
					<p-columnFilter type="text" field="Description" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--IncidentDTDesc-->
				<th>
					<!-- <p-columnFilter type="text" field="IncidentDTDesc" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--StartDateDesc-->
				<th>
					<!-- <p-columnFilter field="StartDateDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown #filterStartDateDesc [ngModel]="value" [options]="lstStartDateDesc" (onChange)="filter($event.value)"
								placeholder="Any" [showClear]="true">
								<ng-template let-value pTemplate="item">
									<span>{{value}}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter> -->
				</th>

				<!--EndDateDesc-->
				<th>
					<!-- <p-columnFilter field="EndDateDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown #filterEndDateDesc [ngModel]="value" [options]="lstEndDateDesc" (onChange)="filter($event.value)"
								placeholder="Any" [showClear]="true">
								<ng-template let-value pTemplate="item">
									<span>{{value}}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter> -->
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="GroupActionTypeDesc">Action Type<p-sortIcon field="GroupActionTypeDesc"></p-sortIcon></th>
				<th pSortableColumn="Description">Description<p-sortIcon field="Description"></p-sortIcon></th>
				<th pSortableColumn="IncidentDT">Action Date<p-sortIcon field="IncidentDT"></p-sortIcon></th>
				<th pSortableColumn="StartDate">Start Date<p-sortIcon field="StartDate"></p-sortIcon></th>
				<th pSortableColumn="EndDate">End Date<p-sortIcon field="EndDate"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-GroupAction>
			<tr [pSelectableRow]="GroupAction" (dblclick)="onRowDblClick(GroupAction)">
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ GroupAction.GroupActionTypeDesc }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" [style.color]="GroupAction.MessageFontColor">
					{{ GroupAction.Description }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ GroupAction.IncidentDTDesc }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ GroupAction.StartDateDesc }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ GroupAction.EndDateDesc }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>
